import * as React from 'react'
import QuestionnaireUserHistoryItemView from './QuestionnaireUserHistoryItemView'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { inject, observer } from 'mobx-react'
import { IQuestionnaireUserHistoryItem } from '../../../Model/Questionnaire'
import * as _ from 'lodash'

export interface IQuestionnaireUserHistoryItemsViewProps {
    className?: string,
    questionnaireUserHistoryItems: Array<IQuestionnaireUserHistoryItem>,
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
@observer
export default class QuestionnaireUserHistoryItemsView
    extends React.Component<IQuestionnaireUserHistoryItemsViewProps> {
    render() {
        const { localizationStore, questionnaireUserHistoryItems, className } = this.props

        return (
            <div className={className} hidden={!questionnaireUserHistoryItems.length}>

                <div className="container p-0">
                    <div className="row">
                        <p>{localizationStore!.t!('questionnaireHistory')}</p>
                    </div>
                    <div className="row blockQuestionnaireHistory">
                        {
                            _.orderBy(questionnaireUserHistoryItems, ['createDate'], ['desc']).map(x =>
                                <QuestionnaireUserHistoryItemView
                                    className="col-12"
                                    key={x.id}
                                    questionnaireUserHistoryItem={x}
                                />)
                        }
                    </div>
                </div>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireUserHistoryItemsView.tsx